module.exports = __webpack_public_path__ + "t.no2.bdbd0761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/t.no2.jpg
// module id = NFck
// module chunks = 0